import en from "./english";
import du from "./dutch";
export const BASIC_TEXTS = {
  en,
  du,
};
